import { render, staticRenderFns } from "./DeleteMulti.vue?vue&type=template&id=3c417ce3&scoped=true&"
import script from "./DeleteMulti.vue?vue&type=script&lang=js&"
export * from "./DeleteMulti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c417ce3",
  null
  
)

export default component.exports